import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e0e58f4a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e58f4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0e58f4a')) {
      api.createRecord('e0e58f4a', component.options)
    } else {
      api.reload('e0e58f4a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e0e58f4a&scoped=true&", function () {
      api.rerender('e0e58f4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_settings/index.vue"
export default component.exports